// CLIENTS---------------------
export const VENDOR_GET = '/vendor/findAllVendor/';
export const VENDOR_POST = '/vendor/createVendor';
export const VENDOR_UPDTAE = '/vendor/editVendor';
export const VENDOR_DELETE = '/vendor/deleteByVendorId';
export const CLIENT_DATA_UPLOAD = '/account/uploadTraderTable';

export const ACCOUNT_GET = '/account/findAllAccount?';
export const ACCOUNT_POST = '/account/createAccount';
export const ACCOUNT_UPDTAE = '/account/editAccount';
export const ACCOUNT_DELETE = '/account/deleteByAccountId';
export const ACCOUNT_DATA_UPLOAD = '/account/uploadAccount'

// WAREHOUSE-------------------
export const WARE_HOUSE_GET = '/warehouse/findAll';
export const WARE_HOUSE_POST = '/warehouse/createWare';
export const WARE_HOUSE_UPDATE = '/warehouse/edit';
export const WARE_HOUSE_DELETE = '/warehouse/deleteById';
export const UPLOAD_WAREHOUSE = '/account/uploadWareHouseTable';

// COMMODITY--------------------
export const COMMODITY_GET = '/commodity/findAllCommodity?';
export const COMMODITY_POST = '/commodity/createCommodity';
export const COMMODITY_UPDATE = '/commodity/editCommodity';
export const COMMODITY_DELETE = '/commodity/deleteByIdCommodity?';
export const COMMODITY_UPLOAD = '/account/uploadCommodityTable';

// COMMODITY CATEGORY--------------------
export const COMMODITY_CATEGORY_GET = '/commodityCategory/findAllCommodityCategory?';
export const COMMODITY_CATEGORY_POST = '/commodityCategory/createCommodityCategory';
export const COMMODITY_CATEGORY_UPDATE = '/commodityCategory/editCommodityCategory';
export const COMMODITY_CATEGORY_DELETE = '/commodityCategory/deleteByIdCommodityCategory?';

// UNIT-------------------------
export const UNIT_GET = '/unit/findAllUnit';
export const UNIT_POST = '/unit/createUnit';
export const UNIT_UPDATE = '/unit/editUnit';
export const UNIT_DELETE = '/unit/deleteByIdUnit';
export const UNIT_UPLOAD = '/account/uploadUnitMeasureTable';

//COMPANY
export const GET_ALL_COMPANY = '/company/findAllCompany';
export const GET_COMPANY_DETAILS = '/company/getAllCompanyDeatils';
export const CREATE_COMPANY = '/company/createCompany';
export const UPDATE_COMPANY = '/company/updateCompanyDetails';
export const DELETE_COMPANY = '/company/deleteByCompanyId';

// INBOUND---------------------
export const GET_INBOUND = '/inbound/findAllInbound';
export const GET_EDIT_INBOUND_DATA = '/inbound/getByUniquyeId';
export const POST_INBOUND = '/inbound/createInbound';
export const UPDATE_INBOUND = '/inbound/editInbound';
export const DELETE_INBOUND = '/inbound/deleteByInboundId';
export const UPLOAD_INBOUND = '/account/uploadInboundTable';

export const GET_DOC = '/inbound/findByUniqueId?';
// export const GET_TAG = '/inbound/findByTagNumber?';
export const GET_TAG = '/stock/findTagNumberByStock?';
export const UPDATE_ALL = '/inbound/multipleUpdate';
export const UPDATE_ALL_SELLING_PRICE = '/inbound/updateMultipleSellingPrice';
export const UPDATE_YARDS = '/inbound/updateYard';
export const UPDATE_SELECTED = '/inbound/selectUpdate';
export const UPDATE_ALL_DESCRIPTION = '/inbound/editAllDescription';
export const UPDATE_ALL_UNITS = '/inbound/updateAllUnitMeasureData';
export const UPDATE_SELECTED_DESCRIPTION = '/inbound/editSelectedDescription';
export const UPDATE_SELECTED_UNIT = '/inbound/selectUnitUpdate';
export const UPDATE_INVENTORY_TRANSACTION = '/inbound/updateInventoryValue';
export const GET_BY_TAG = '/inbound/findById?';
export const GET_BY_DOC = '/inbound/findByDocumentNumber?';
export const GET_PRINT_CONTENT = '/inbound/getSameCommodityData?';
export const GET_EXCEL_CONTENT = '/inbound/getExcelData?';
export const UPDATE_TAG_BU_STATUS = 'inbound/editTagNumberByStatus';

export const GET_PROCESSED_DATA = '/inbound/getProcessedInbounds';
export const POST_PROCESSED_DATA = '/inbound/inprogressInbound';
export const UPDATE_PROCESSED_DATA = '/inbound/processInbound';

export const GET_INVOICE_DATA = '/inbound/getInvoiceData?';
export const GET_RECEIVER_DATA = '/inbound/getReceiverPrint?';
// INVENTORY---------------------
export const GET_INVENTORY = '/inbound/getAllInventory?';
export const UPDATE_INVENTORY = '/inbound/updateInventory';
export const PROFIT_LOSS_GET = '/inbound/profirLoss?';

// DASHBOARD---------------------
export const DASHBOARD_GET = '/dashboard/getDashboardData';

// Support -----------------
export const POST_SUPPORT = '/support/createTicket';
export const GET_SUPPORT = '/support/getTicket';
export const GET_SUPPORT_ADMIN = '/support/getAllTicketShowForAdmin';
export const UPDATE_SUPPORT_ADMIN = '/support/updateStatus';
export const POST_CHAT = '/chat/addMessage';
export const GET_CHAT = '/chat/getShowAllTicketResponeForQa';
export const GET_TICKET_BY_ID = '/support/getTicketById';

// Stock ------------------------------------------------------
// export const GET_STOCK = '/stock/findAllStock';
export const GET_STOCK = '/inbound/findStockData';
export const CREATE_STOCK = '/stock/stockCreate';
export const UPDATE_STOCK = '/stock/updateStock';
export const FIND_TAG_IN_STOCK = 'stock/findByTagNumberForStok';

// Accounting ------------------------------------------------------
export const GET_ACCOUNTING_DATA = '/inbound/findAllPrice?';

// TransactionHistory ------------------------------------------------------
export const GET_TRANSACTION_HISTORY = '/inbound/controlNumberHistory';
export const GET_DELETED_TRANSACTION_HISTORY = '/inbound/getDeleteInventoryRecord';

// DownloadCSV ------------------------------------------------------
export const GET_TRANSACTION_CSV = '/imsCsvDump/csvDump';
export const GET_ACCOUNT_CSV = '/imsCsvDump/imsAccountCsvDumpFunction';
export const GET_TRADER_CSV = '/imsCsvDump/imsTraderCsvDumpFunction';
export const GET_USER_CSV = '/imsCsvDump/imsUserCsvDumpFunction';
export const GET_COMMODITY_CSV = '/imsCsvDump/imsCommoditesCsvDumpFunction';

// USER-------------------------
export const USER_GET = '/users/findAll';
export const USER_POST = '/users/signUp';
export const USER_UPDATE = '/users/updateUsers';
export const USER_DELETE = '';
